// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__17h6G","validationTips":"StatementDescriptor_validationTips__N0jRZ"};